import { useState, useRef, useEffect } from "react";

function RecordingTime({
  isRecording,
  startTime,
  setStartTime,
  pausedTime,
  resetTime,
  setResetTime,
}) {
  const [duration, setDuration] = useState(0);
  const durationRef = useRef();
  durationRef.current = duration;

  useEffect(() => {
    if (!resetTime) return;

    if (resetTime) {
      setDuration(0);
      setResetTime(false);
    }
  }, [resetTime, setResetTime]);

  useEffect(() => {
    let intervalId = null;
    if (isRecording) {
      if (pausedTime) {
        setDuration((s) => {
          return s + pausedTime;
        });
      }

      intervalId = setInterval(() => {
        setDuration((s) => s + 1);
      }, 1000);
    } else if (!isRecording && durationRef.current !== 0) {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [isRecording, startTime, setStartTime, pausedTime]);

  function getFormattedTime() {
    const d = Math.round(duration);
    const minutes = Math.floor(d / 60);
    const remainingSeconds = d % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  }

  return <span className="text-dark mt-2">{getFormattedTime()}</span>;
}
export default RecordingTime;
